import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=4cb2b5fc"
import script from "./balance.vue?vue&type=script&lang=js"
export * from "./balance.vue?vue&type=script&lang=js"
import style0 from "./balance.vue?vue&type=style&index=0&id=4cb2b5fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports